var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0m0 10.982a4.983 4.983 0 1 1 .002-9.966A4.983 4.983 0 0 1 6 10.982m.639-5.293-.34-.079V3.812c.509.07.823.388.877.78a.106.106 0 0 0 .106.091h.601a.11.11 0 0 0 .107-.117c-.082-.835-.769-1.37-1.686-1.463v-.438a.107.107 0 0 0-.107-.107H5.82a.107.107 0 0 0-.108.107v.442c-.948.093-1.69.616-1.69 1.594 0 .905.667 1.342 1.368 1.51l.33.084v1.91c-.592-.078-.924-.394-.992-.82a.11.11 0 0 0-.106-.089h-.619a.107.107 0 0 0-.107.117c.06.737.62 1.414 1.811 1.501v.42c0 .06.048.108.107.108h.38a.11.11 0 0 0 .108-.109L6.3 8.91c1.049-.092 1.799-.654 1.799-1.66-.002-.93-.592-1.345-1.46-1.56m-.919-.217a2 2 0 0 1-.2-.067c-.453-.163-.664-.427-.664-.767 0-.486.369-.763.864-.826zM6.3 8.21V6.42l.118.029c.633.193.846.46.846.872 0 .523-.394.838-.964.889"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingIcon);
export default __webpack_public_path__ + "static/media/billing-icon.788848615b00c4c876bcbdd209719def.svg";
export { ForwardRef as ReactComponent };